import { Serializers, SerializerValue } from "@megaron/serializers";
import { uuidSerializer } from "@megaron/uuid";

import { customerCategories, customerStatuses } from "./customerFilters";

export const analyticsTimeUnits = ["hours", "days", "months", "years"] as const;
export type AnalyticsTimeUnit = (typeof analyticsTimeUnits)[number];

export const customerAnalyticsSortFields = [
  "name",
  "profit",
  "orderCount",
  "size",
  "value",
  "cost",
  "lastSaleTime",
  "firstSaleTime",
  "productCount",
  "absolutePotential",
  "itemCount",
  "potentialRealization",
  "interactionCount",
  "firstInteractionTime",
  "lastInteractionTime",
  "groupCount",
  "realizedGroupCount",
  "potentialGroupCount",
  "unrealizedGroupCount",
  "groupRealization",
] as const;
export type CustomerAnalyticsSortField = (typeof customerAnalyticsSortFields)[number];

export const analyticsSortOrders = ["ASC", "DESC"] as const;
export type AnalyticsSortOrder = (typeof analyticsSortOrders)[number];

export const customerAnalyticsSortSerializer = Serializers.object({
  agg: Serializers.string.nullable(),
  customColumn: Serializers.string.nullable(),
  fieldName: Serializers.stringOneOf(...customerAnalyticsSortFields),
  order: Serializers.stringOneOf(...analyticsSortOrders),
});

export type CustomerAnalyticsSort = SerializerValue<typeof customerAnalyticsSortSerializer>;

export const customerAnalyticsViewFiltersSerializer = Serializers.object({
  aggName: Serializers.string.nullable(),
  customerId: uuidSerializer.array(),
  isMyRegion: Serializers.boolean,
  region: Serializers.string.array(),
  category: Serializers.stringOneOf(...customerCategories).array(),
  status: Serializers.stringOneOf(...customerStatuses).array(),
  sort: customerAnalyticsSortSerializer,
  timeStart: Serializers.datetime,
  timeEnd: Serializers.datetime,
  timeUnit: Serializers.stringOneOf(...analyticsTimeUnits),
  unitCount: Serializers.integer,
  selectedTimeName: Serializers.string,
  productGroups: Serializers.string.array(),
}).partial();

export type CustomerAnalyticsViewFilters = SerializerValue<typeof customerAnalyticsViewFiltersSerializer>;
